// extracted by mini-css-extract-plugin
export var btn = "L_mB y_s3 y_sK d_bz d_bP d_bD d_dw";
export var full = "L_wJ d_w d_H";
export var hoverStyle = "L_mF";
export var zoom = "L_mG";